import { memo } from 'react';

import { XIcon as CloseIcon, EyeIcon } from '@air/design-icons';

export type CanvasTopBarViewOnlyNoticeProps = {
  onDismiss: () => void;
};

export const CanvasTopBarViewOnlyNotice = memo(({ onDismiss }: CanvasTopBarViewOnlyNoticeProps) => {
  return (
    <div
      className="pointer-events-auto flex shrink-0 items-center gap-1.5 rounded-full bg-gray-3 px-3 py-1 text-gray-11"
      data-testid="CANVAS_TOP_BAR_VIEW_ONLY_NOTICE"
    >
      <EyeIcon aria-hidden size="sm" />
      <span className="text-12">You can only view this file</span>
      <button
        aria-label="Dismiss view-only notice"
        className="flex size-4 items-center justify-center rounded-full hover:bg-gray-5"
        data-testid="CANVAS_TOP_BAR_VIEW_ONLY_DISMISS"
        onClick={onDismiss}
        type="button"
      >
        <CloseIcon aria-hidden size="xs" />
      </button>
    </div>
  );
});

CanvasTopBarViewOnlyNotice.displayName = 'CanvasTopBarViewOnlyNotice';
